export default __webpack_public_path__ + "static/media/personal.830d3626.svg";